import React from 'react';
import { Check } from 'lucide-react';
import { Button, Section } from './Shared';
import { PRICE_USD, scrollToId } from '../lib/checkout';
const includes = ['Investigación central Nos Mienten.', '6 tomos principales.', '3 investigaciones especiales incluidas.', 'Acceso digital inmediato.', 'Formato digital.', 'Lectura desde celular, tablet o PC.', 'Pago único.', 'Sin suscripción.'];
export function WhatsIncluded() {
  return <Section id="incluye" data-id="element-4" data-mp="1drrhtwlkwu2v">
      <div className="max-w-3xl mx-auto" data-id="element-5" data-mp="1ip1enxbas80q">
        <h2 className="font-serif text-2xl md:text-4xl font-bold text-white mb-6 text-center" data-id="element-6" data-mp="1ipsxe7jsqb9l">
          Qué incluye el archivo Nos Mienten
        </h2>

        <div className="bg-brand-dark border border-brand-gold/25 rounded-2xl p-5 md:p-8" data-id="element-7" data-mp="1sn7e889mt22f">
          <ul className="grid gap-3 sm:grid-cols-2" data-id="element-8" data-mp="1skup9b5ghrfv">
            {includes.map(item => <li key={item} className="flex items-start gap-2.5 text-[13px] md:text-sm text-brand-offWhite leading-snug" data-id="element-9" data-mp="2z5m18q1ve715">
                <Check className="w-4 h-4 text-brand-gold shrink-0 mt-0.5" data-id="element-10" data-mp="1bp5bs2xsug7p" />
                <span data-id="element-11" data-mp="16rnbt21rfbbu">{item}</span>
              </li>)}
          </ul>

          <p className="text-center text-sm md:text-base text-brand-muted mt-6 pt-5 border-t border-brand-card" data-id="element-12" data-mp="12oh4dr2wve3s">
            Archivo completo disponible por{' '}
            <span className="text-brand-gold font-medium" data-id="element-13" data-mp="xs8kk0drqwqa">{PRICE_USD}</span>.
          </p>
        </div>
      </div>
    </Section>;
}
const volumes = [{
  num: 1,
  title: 'El cielo no estaba vacío',
  line: 'Registros antiguos, casos tempranos y el origen de muchas preguntas.'
}, {
  num: 2,
  title: 'El nacimiento del fenómeno moderno',
  line: 'Roswell, Área 51, prensa, archivos y primeras investigaciones.'
}, {
  num: 3,
  title: 'Casos militares y pilotos',
  line: 'Informes, persecuciones y encuentros observados por personal entrenado.'
}, {
  num: 4,
  title: 'Los contactados',
  line: 'Relatos, patrones, figuras recurrentes e hipótesis alrededor del contacto.'
}, {
  num: 5,
  title: 'UAP y revelaciones recientes',
  line: 'Videos oficiales, informes públicos y el giro moderno de la conversación.'
}, {
  num: 6,
  title: 'Hipótesis y futuro',
  line: 'Lecturas posibles, límites de la evidencia y preguntas que siguen abiertas.'
}];
export function Volumes() {
  return <Section id="tomos" darker data-id="element-14" data-mp="e5f5caqfnsuq">
      <div className="max-w-4xl mx-auto" data-id="element-15" data-mp="e66zri8ankjf">
        <h2 className="font-serif text-2xl md:text-4xl font-bold text-white mb-6 md:mb-8 text-center" data-id="element-16" data-mp="j3gnmtg1bo55">
          La investigación central se abre en 6 tomos.
        </h2>

        <ul className="grid gap-3 md:grid-cols-2" data-id="element-17" data-mp="9ddvevgqme7v">
          {volumes.map(vol => <li key={vol.num} className="flex gap-4 bg-brand-anthracite border border-brand-card rounded-xl p-4 md:p-5" data-id="element-18" data-mp="9b14vtwwyvj7">
              <span className="font-serif text-xl md:text-2xl text-brand-gold/60 shrink-0 leading-none pt-0.5" data-id="element-19" data-mp="11ugi2a6atq5t">
                0{vol.num}
              </span>
              <div data-id="element-20" data-mp="2hlaghj9zoxl9">
                <h3 className="text-sm md:text-base font-bold text-white mb-1" data-id="element-21" data-mp="2hjz9zbp5tbqg">
                  {vol.title}
                </h3>
                <p className="text-xs md:text-sm text-brand-muted leading-relaxed" data-id="element-22" data-mp="2w93s6svyffyk">
                  {vol.line}
                </p>
              </div>
            </li>)}
        </ul>

        <div className="mt-8 text-center" data-id="element-23" data-mp="23lrfrbjicoiz">
          <Button onClick={() => scrollToId('oferta')} data-id="element-24" data-mp="1ymejk06qy53q">
            VER ACCESO COMPLETO
          </Button>
        </div>
      </div>
    </Section>;
}
const spreads = [{
  img: 'https://cdn.magicpatterns.com/uploads/8jKGGLubxiNtFw7vr7Pm5z/01_papiro_tulli.jpg',
  caption: 'Ficha de caso: el Papiro de Tulli'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/92nDGPTtMryQafrMaenD1s/02_presentacion_militar.jpg',
  caption: 'Presentación de volumen: casos militares'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/5xhTvBgmzqPu3988Ff1FKF/03_testimonio_militar.jpg',
  caption: 'Por qué el testimonio militar importa'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/66ZK8mvcWqeob4nQ52MqzR/04_clasificacion_encuentros.jpg',
  caption: 'Clasificación de encuentros cercanos'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/f48j9qEhRuPcsKKUUNbczp/05_carta_estelar_betty.jpg',
  caption: 'Análisis: la carta estelar de Betty'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/jdAn7kofXeAcM1rZmCLjai/07_rendlesham.jpg',
  caption: 'Cronología del caso Rendlesham'
}];
export function InsideLook() {
  return <Section data-id="element-25" data-mp="1axiz98x8pp7o">
      <div className="max-w-4xl mx-auto" data-id="element-26" data-mp="1axsi8cjvaw3v">
        <h2 className="font-serif text-2xl md:text-4xl font-bold text-white mb-3 text-center" data-id="element-27" data-mp="1fthheerz6azn">
          Un vistazo al interior del archivo
        </h2>
        <p className="text-sm md:text-base text-brand-muted text-center max-w-2xl mx-auto mb-8" data-id="element-28" data-mp="1krssstxx4tjz">
          No mostramos todo. Solo lo suficiente para que veas el tipo de
          recorrido que vas a encontrar dentro.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-5" data-id="element-29" data-mp="35b4vlfehwef0">
          {spreads.map(spread => <figure key={spread.caption} data-id="element-30" data-mp="30dmntsc7s58l">
              <div className="rounded-lg overflow-hidden border border-brand-card bg-brand-dark" data-id="element-31" data-mp="30eo183gpd3th">
                <img src={spread.img} alt={spread.caption} loading="lazy" className="w-full h-full object-cover object-top aspect-[3/4]" data-id="element-32" data-mp="2vfl73e29gi0a" />
              </div>
              <figcaption className="text-[11px] md:text-xs text-brand-muted mt-2 text-center" data-id="element-33" data-mp="3janv5jt8qhfp">
                {spread.caption}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </Section>;
}
const investigations = [{
  title: 'El Libro Negro de los Misterios Modernos',
  desc: 'Casos extraños, desapariciones, zonas de misterio y episodios que siguen generando teorías.',
  img: 'https://cdn.magicpatterns.com/uploads/muv5cDvaQo563DWbnPUxWq/ChatGPT_Image_26_jun_2026,_18_43_48.png'
}, {
  title: 'Los Archivos Desclasificados',
  desc: 'Documentos, memorandos, expedientes y contexto para leerlos sin perderse en el ruido.',
  img: 'https://cdn.magicpatterns.com/uploads/aPyt7oTA5hXLKB4qtibUJ2/ChatGPT_Image_26_jun_2026,_18_40_49.png'
}, {
  title: 'Las Grandes Civilizaciones Perdidas',
  desc: 'Atlántida, Göbekli Tepe, Puma Punku, Yonaguni, Nazca y otros enigmas arqueológicos.',
  img: 'https://cdn.magicpatterns.com/uploads/9mknbYHtgSMxsyghVyTgAh/ChatGPT_Image_26_jun_2026,_18_40_36.png'
}];
export function IncludedInvestigations() {
  return <Section darker data-id="element-34" data-mp="1hef9o7fkc6o4">
      <div className="max-w-4xl mx-auto" data-id="element-35" data-mp="1hfzvn8ntahad">
        <h2 className="font-serif text-2xl md:text-4xl font-bold text-white mb-3 text-center" data-id="element-36" data-mp="36sk3qqulcy7l">
          Además, recibes 3 investigaciones especiales.
        </h2>
        <p className="text-sm md:text-base text-brand-muted text-center max-w-2xl mx-auto mb-8" data-id="element-37" data-mp="3bpk90zjm9wxn">
          Tres recorridos complementarios para ampliar el universo del archivo
          principal.
        </p>

        <div className="grid gap-4 md:grid-cols-3" data-id="element-38" data-mp="19ue534hdgc9b">
          {investigations.map(item => <article key={item.title} className="bg-brand-anthracite border border-brand-card rounded-xl overflow-hidden" data-id="element-39" data-mp="153o19volghgq">
              <div className="bg-brand-dark p-4" data-id="element-40" data-mp="1it7wmgfuicg0">
                <img src={item.img} alt={`Portada de ${item.title}`} loading="lazy" className="w-full h-auto max-w-[170px] md:max-w-none mx-auto object-contain rounded shadow-xl" data-id="element-41" data-mp="1dwhgxu7ydiv4" />
              </div>
              <div className="p-4 md:p-5" data-id="element-42" data-mp="3ukbw176dizc5">
                <h3 className="text-sm md:text-base font-bold text-white mb-2" data-id="element-43" data-mp="3ulem5cvvgxr0">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-brand-muted leading-relaxed" data-id="element-44" data-mp="3pnle0eb0dto3">
                  {item.desc}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </Section>;
}
const reasons = ['Es una biblioteca digital para leer por partes.', 'Puedes volver a consultar casos, cronologías y testimonios.', 'Reúne temas que normalmente aparecen dispersos.', 'Está pensado para quienes disfrutan investigar, comparar y hacerse preguntas.', 'No requiere conocimientos previos.', 'No es una suscripción.'];
export function WhyWorthIt() {
  return <Section data-id="element-45" data-mp="2urog7yg0wvud">
      <div className="max-w-3xl mx-auto" data-id="element-46" data-mp="2ur5819g6dltj">
        <h2 className="font-serif text-2xl md:text-4xl font-bold text-white mb-6 text-center" data-id="element-47" data-mp="2uq3la7psravz">
          No es contenido para mirar una vez y olvidar.
        </h2>
        <ul className="grid gap-2.5 sm:grid-cols-2" data-id="element-48" data-mp="a27e9dbg0fcv">
          {reasons.map(item => <li key={item} className="flex items-start gap-2.5 text-[13px] md:text-sm text-brand-offWhite bg-brand-dark border border-brand-card rounded-lg p-3.5 leading-snug" data-id="element-49" data-mp="e2hurjwv2o5z">
              <Check className="w-4 h-4 text-brand-gold shrink-0 mt-0.5" data-id="element-50" data-mp="1ukj9qze1d380" />
              <span data-id="element-51" data-mp="1pshzfj0fhmkm">{item}</span>
            </li>)}
        </ul>
      </div>
    </Section>;
}